import React from 'react';
import BookOfBusinessTable from 'components/book-of-business/BookOfBusinessTable';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { createStyles } from '../../globalStyles';

const BookOfBusinessPage = (): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  return (
    <div className={clsx(classes.pageWrapper, classes.simplePageWrapper)}>
      <PageHeader
        title="Book Of Business"
        subtitle="Here you have the ability to browse all Summary Files"
        onBackButtonClick={onBackButtonClick}
      />
      <BookOfBusinessTable />
    </div>
  );
};

export default BookOfBusinessPage;
